import { useAsyncEffect, useRouter } from "@relode/core";

import { JobActions } from "./jobActions";
import { JobState } from "./jobState";

export const useJobHandlers = (state: JobState, actions: JobActions) => {
    const {
        match: {
            params: { jobId },
        },
    } = useRouter();

    useAsyncEffect(async () => {
        await actions.loadJob(jobId);
    }, [jobId]);
};
